export default {
  v3OfficialTopUpCenterTitle: '公式チャージセンター',
  v3OfficialTopUpCenterKeyword: '公式チャージセンター',
  v3OfficialTopUpCenterDescription: '公式チャージセンター',
  v3SafeAndFast: '安全で確実、即時反映いたします',
  v3Shop: 'ショップ',
  v3ShoppingCart: 'カート',
  v3MembershipCenter: 'プレミアムセンター',
  v3Login: 'ログイン',
  v3Account: 'アカウント',
  v3EnterAccountName: 'アカウント名を入力してください',
  v3Password: 'パスワード',
  v3EnterPassword: 'パスワードを入力してください',
  v3ForgotPassword: 'パスワードをお忘れですか',
  v3EnterUID: 'UIDを入力してください',
  v3OTP: 'OTP',
  v3EnterOTP: 'OTPを入力してください',
  v3SelectTopUpCharacter: 'チャージするキャラクターを選択してください',
  v3SelectServer: 'サーバーを選択してください',
  v3Confirm: '確定',
  v3CharacterNotFound:
    'キャラクターが見つからない場合は、まずゲームアプリでキャラクターにログインしてからチャージページにアクセスするか、カスタマーサポートにお問い合わせください',
  v3Logout: 'ログアウト',
  v3SwitchAccount: 'アカウント切り替え',
  v3MyCoupons: 'マイクーポン',
  v3BenefitsCenter: 'プレミアムセンター',
  v3TopUpBenefits: 'チャージボーナス',
  v3MoreSettings: 'その他設定',
  v3RememberLoginStatus: 'ログイン状態を保存',
  v3OrderQuery: '注文履歴',
  v3ContactCustomerService: 'お問い合わせ',
  v3LoginWithApp: 'アプリでログイン',
  v3ChooseOtherLoginMethod: '他のログイン方法を選択',
  v3ConnectingToGameApp: 'ゲームアプリに接続しています',
  v3EnsureGameInstalled:
    'お使いの端末にゲームがインストールされていることをご確認ください。ゲームが応答しない、またはログインに失敗した場合は、アプリストアから最新版にアップデートするか、別のブラウザをお試しください。',
  v3OpenGame: 'ゲームを開く',
  v3DownloadGame: 'ゲームをダウンロード',
  v3UpdateGameIfOpenFails:
    'ゲームが開けない場合は、アプリストアから最新版にアップデートしてください。',
  v3ClickToDownloadLatestVersion:
    'または、ゲームダウンロードボタンをクリックして、最新版をダウンロードすることもできます。',
  v3LoggingIntoOfficialTopUpCenter:
    '「公式チャージセンター」にログインしています',
  v3CurrentAccount: '現在のアカウント：xxxxxxxxxx',
  v3WelcomeToOfficialTopUpCenter: '公式チャージセンターへようこそ',
  v3OfficialAuthorizedLogin: '公式認証ログイン、安全で安心',
  v3TermsOfService: '利用規約',
  v3PrivacyPolicy: 'プライバシーポリシー',
  v3ThirdPartySocialAccountDescription: 'サードパーティーSNSアカウントについて',
  v3BindSocialAccountInGameFirst:
    'まずゲーム内のユーザーセンターでSNSアカウントの連携を完了してから、連携したSNSアカウントでログインしてください。',
  v3FirstTopUp15PercentOff: '初回チャージで最大15%OFF',
  v3MoreTopUpRebates: 'さらにお得なチャージ特典が続々登場',
  v3LoginToViewOffers: 'ログインして特典を確認',
  v3TopUpEnvironmentChecking: 'チャージ環境をチェック中……',
  v3SafeToUse: '安全安心で利用できる',
  v3LimitedTimeBenefits: '期間限定特典',
  v3EventRules: 'イベントルール',
  v3MoreEvents: 'その他イベント',
  v3Claim: '受取',
  v3Completed: '完了済',
  v3GoTo: '向かう',
  v3ViewDetails: '詳細情報',
  v3RecommendedProducts: 'おすすめ商品',
  v3SearchProductName: '商品名を検索',
  v3AllCategories: '全てのカテゴリー',
  v3PopularSort: '人気順',
  v3PriceAscending: '価格安い順',
  v3PriceDescending: '価格高い順',
  v3DiamondBonus10Percent: 'ダイヤ10%増量',
  v3YuanbaoBonus10Percent: '元宝10%増量',
  v3ExtraBonus10Percent: '10%ボーナス',
  v3FirstTopUpDouble: '初回チャージ2倍',
  v3FirstExtraBonus: '初回ボーナス',
  v3ProductDetails: '商品詳細',
  v3AddToCart: 'カートに追加',
  v3AddedToCart: 'カートに追加しました',
  v3BuyNow: '今すぐ購入',
  v3NoItemsInCart: 'まだカートに商品が追加されていません',
  v3SelectedItemsN: '選択された商品（${n}）',
  v3RemoveFromCart: 'カートから移動しますか？',
  v3Yes: 'はい',
  v3No: 'いいえ',
  v3LimitOnePerPurchase: 'この商品は1回につき1点までのご購入となります',
  v3ItemPrice: '商品価格',
  v3Tax: '税',
  v3ExtraGift: 'ボーナス',
  v3Total: '合計',
  v3ProceedToPayment: 'お支払いへ',
  v3SelectCoupon: 'クーポンを選択',
  v3UnavailableCoupons: '使用不可クーポン',
  v3OneCouponPerOrder: '1回のご注文につき1枚のみ使用可能です',
  v3DiscountCoupon: '割引クーポン',
  v3ThresholdCoupon: '定額割引クーポン',
  v3MinSpendCoupon: 'xx USD以上で利用可能',
  v3MaxDiscountCoupon: '最大xxxx USDまで割引',
  v3LimitedChannel: '指定チャンネルのみ利用可能',
  v3AllChannels: '全チャンネルで利用可能',
  v3SpecificProducts: '指定商品のみ利用可能',
  v3AllProducts: 'すべての商品を利用可能',
  v3NotYetTimeToUse: '利用時間外です',
  v3Expired: '期限切れ',
  v3Used: '使用済み',
  v3ValidityPeriod: '有効期間：',
  v3ConfirmUse: '使用する',
  v3ChangeProduct: '商品変更',
  v3ConfirmPaymentOrder: '支払い確定',
  v3StoredValueRole: 'チャージキャラ',
  v3TotalNProducts: '商品数：${n}個',
  v3SelectPaymentMethod: '支払い方法を選択',
  v3PayNow: '今すぐ支払う',
  v3MorePaymentMethods: 'その他支払い方法',
  v3NoAvailablePaymentMethodContactSupport:
    'ご利用可能な支払い方法が見つかりませんか？カスタマーサポートにお問い合わせください',
  v3AvailableCoupons: '使用可能クーポン',
  v3Extra10Percent: '10%増量',
  v3LastSelection: '前回選択',
  v3RecommendedUsage: 'おすすめ',
  v3PopularChoice: '人気選択',
  v3PaymentSuccess: 'お支払いが完了いたしました',
  v3PaymentFailure: '支払いが失敗しました',
  v3TopUpFailureMessage:
    '誠に申し訳ございませんが、チャージに失敗いたしました。お手数ですが、再度ご注文をお試しいただくか、下記のカスタマーサポートボタンよりお問い合わせください。',
  v3Game: 'ゲーム',
  v3UID: 'UID',
  v3OrderNumber: '注文番号',
  v3ProductContent: '商品内容',
  v3ViewProductDetails: '商品詳細を確認',
  v3PaymentMethod: 'お支払い方法',
  v3Complete: '完了',
  v3TopUpAgain: 'もう一度チャージ',
  v3FriendlyReminderSaveOrderInfo:
    'ご注意：注文情報のスクリーンショットを保存していただくと、迅速に対応させていただけます。',
  v3RechargeAgain: '再チャージ',
  v3TransactionInProgress: '取引は進行中です',
  v3CompletePaymentInChannel:
    '決済チャネルへ移動し、注文のお支払いを完了してください。',
  v3RestAssuredFastDeliveryAfterPayment:
    'ご安心ください。お支払い結果を確認次第、最速でアイテムをお届けいたします。',
  v3SaveOrderInfoForProgress:
    '取引の進捗を確認するため、注文情報のスクリーンショットを保存していただくことをおすすめいたします。',
  v3PaymentCompleted: '支払い完了した',
  v3AddToHomeScreen: 'ホーム画面に追加',
  v3AddShortcutForBonus:
    'デスクトップショートカットを追加、追加ボーナスをゲット',
  v3ShareSuccess: 'シェアが完了しました',
  v3ShareFailure: 'シェアに失敗しました',
  v3RewardClaimed: '受け取りました',
  v3RewardClaimFailed: 'ボーナス受領に失敗しました',
  v3EventNotStarted: 'イベント未開放',
  v3EventEnded: 'イベントが終わりました',
  v3ClickSelectCoupon: 'クーポンを選択するにはクリック',
  v3CouponsRecommendedUsed: 'おすすめのクーポンを使用しました',
  v3CouponsSelected: '選択したクーポン',
  v3NoCouponsAvaliable: '利用可能なクーポンはありません',
  v3SupplementStatus: '状態',
  v3SupplementNormal: '正常',
  v3SupplementBanned: '禁止されました',
  v3SupplementPendingPayment: '支払い待ち',
  v3SupplementSwitchCharacter: 'キャラクターを切り替える',
  v3SupplementAccountInfoInvalid: 'アカウント情報が無効です',
  v3SupplementContactGSForTopUpLink:
    'GSに連絡してチャージリンクを取得してください',
  v3SupplementTopUpCompleted: 'チャージ完了：',
  v3SupplementTotalRefundOrders: '合計{}件の返金注文',
  v3SupplementPendingSupplementAmount: '未払い金額：',
  v3SupplementAccountCharacterNormalNoPaymentNeeded:
    'アカウント/キャラクターは正常で、支払いは不要です',
  v3SupplementEnjoyYourGame: 'ゲームをお楽しみください!!',
  v3SupplementOrderInformation: '注文情報',
  v3SupplementPendingPaymentAmount: '未払い金額：',
  v3LookUpCouponRule: 'クーポン配布ルール確認',
  v3SwitchOldVersion: '旧バージョンに切り替え',
  v3FirstTopUpGiveaway: '初回ボーナス',
  v3SecureConnection: '安全接続中',
  v3RequestTimeOut:
    '読み込みがタイムアウトしました。後ほど再度お試しください。',
  v3ConfirmLeave: '離れますか？',
  v3NoSubmitOrder:
    'カートの商品がまだ決済されていません。離れると、お気に入りの商品を逃してしまう可能性がございます！',
  v3ContinueSubmit: '買い物を続ける',
  v3LeaveSubmit: '離れる',
  v3RecentBug: '最近の購入',
  v3ScanCodeLogin: 'Scan Code Login',
  v3BindRole: 'Bind Role',
  v3ScanLoading: 'loading...',
  v3ScanExpired: 'QR code expired',
  v3ScanRefreshClick: 'Click to refresh',
  v3ScanRefreshTip: 'Please refresh and scan again',
  v3ScanRefresh: 'Refresh',
  v3ScanSucc: 'Scanned successfully',
  v3ScanAuth: 'Please confirm on your phone',
  v3ScanAuthSuccess: 'Authorization successful',
  v3ScanAuthSuccessTip: 'Logging in...',
  v3ScanUnauthorized: 'Authorization failed',
  v3ScanRefreshTip2: 'Log in to the game app to scan',
  v3ScanGuide: 'Scan Guide',
  v3ScanLoginError: 'Login error, please refresh and retry',
  v3ThirdPartyLogin: 'Third-party Login',
  v3NoMyLoginMethod: "Don't have my login method?",
  v3AccountPasswordLogin: 'Please enter account to bind game character',
  v3PwaTapShareOrMenuIcon: 'ブラウザのツールバーにある「共有」または「メニュー」アイコンをタップします',
  v3PwaFindAndTapAddToHomeScreen: 'オプションから「ホーム画面に追加」を見つけてタップします',
  v3LaunchFromDesktopAndRewardToMailbox: 'デスクトップから起動してください\nキャラクター選択後、報酬はメールに届きます',
  v3ClaimSuccessCheckMailbox: '受取成功\nゲーム内メールをご確認ください',
  v3ProductLimitOnceBadge: '1 回限り',
  v3ProductWeeklyOnlyBadge: '週限定',
  v3ProductMonthlyOnlyBadge: '月限定',
  v3ProductDiscountBadge: '**% 引き',
};
